import React from 'react'
import '../AdminCommonCom/Header.css'

const StudentFooter = () => {
  return (
    <div className="row p-0 py-2 text-center m-0 text-white fixed-bottom" style={{background: "linear-gradient(115deg, #242443, #162e29)",color:"#ffc107"}}>
        <span className='footer-text'>© 2025 JAIN BOARDING KOLHAPUR | Managed By : TechnoAarv Solution</span>
      </div>
  )
}

export default StudentFooter